import { render } from "./FulfillmentPolicy.vue?vue&type=template&id=21978cf7"
import script from "./FulfillmentPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./FulfillmentPolicy.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Support/FulfillmentPolicy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21978cf7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21978cf7', __exports__)) {
    api.reload('21978cf7', __exports__)
  }
  
  module.hot.accept("./FulfillmentPolicy.vue?vue&type=template&id=21978cf7", () => {
    api.rerender('21978cf7', render)
  })

}


export default __exports__